import { render, staticRenderFns } from "./addressEditDialog.vue?vue&type=template&id=8b2c58e4&scoped=true"
import script from "./addressEditDialog.vue?vue&type=script&lang=js"
export * from "./addressEditDialog.vue?vue&type=script&lang=js"
import style0 from "./addressEditDialog.vue?vue&type=style&index=0&id=8b2c58e4&prod&lang=scss&scoped=true"
import style1 from "./addressEditDialog.vue?vue&type=style&index=1&id=8b2c58e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c58e4",
  null
  
)

export default component.exports